module.exports = __webpack_public_path__ + "static/media/bannerImg.5b2a0b49.svg";